import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-273.78 -348.44 1955.56 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1270 146 1134 10Q1106 -18 1066.0 -18.0Q1026 -18 998 10L704 304L410 10Q382 -18 342.0 -18.0Q302 -18 274 10L138 146Q110 174 110.0 214.0Q110 254 138 282L432 576L138 870Q110 898 110.0 938.0Q110 978 138 1006L274 1142Q302 1170 342.0 1170.0Q382 1170 410 1142L704 848L998 1142Q1026 1170 1066.0 1170.0Q1106 1170 1134 1142L1270 1006Q1298 978 1298.0 938.0Q1298 898 1270 870L976 576L1270 282Q1298 254 1298.0 214.0Q1298 174 1270 146Z"
	})
});
export default SvgClose;
